import { __decorate } from "tslib";
import { AccessGuard, accessGuardData, provideFeatureAddonRoutes } from '@core/frontend-shared';
import { FrontendFeaturePlugin } from '@core/frontend-shared/feature';
import { ClassName } from '@core/shared/class-name';
import * as i0 from "@angular/core";
let UsersPasswordResetQrcodeFrontendManagementFeature = /*#__PURE__*/(() => {
  let UsersPasswordResetQrcodeFrontendManagementFeature = class UsersPasswordResetQrcodeFrontendManagementFeature extends FrontendFeaturePlugin {
    getFeatureContext() {
      return {"package":"@common/users-password-reset-qrcode/frontend-management","featureId":"common-users-password-reset-qrcode"};
    }
    getFeatureFunctionality(functionality) {
      functionality.defineMenuItems({
        managementToolbar: {
          basePath: 'management',
          items: [{
            priority: 5,
            label: 'Passwort-Reset Link',
            icon: 'lock',
            routerLink: 'password-link',
            simpleAbilityCheck: {
              allow: ["Feature.common-users-password-reset-qrcode.Manage", "Programmatic.common-users.IsCompanyManager"]
            }
          }]
        }
      });
    }
    static {
      this.ɵfac = /*@__PURE__*/(() => {
        let ɵUsersPasswordResetQrcodeFrontendManagementFeature_BaseFactory;
        return function UsersPasswordResetQrcodeFrontendManagementFeature_Factory(__ngFactoryType__) {
          return (ɵUsersPasswordResetQrcodeFrontendManagementFeature_BaseFactory || (ɵUsersPasswordResetQrcodeFrontendManagementFeature_BaseFactory = i0.ɵɵgetInheritedFactory(UsersPasswordResetQrcodeFrontendManagementFeature)))(__ngFactoryType__ || UsersPasswordResetQrcodeFrontendManagementFeature);
        };
      })();
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: UsersPasswordResetQrcodeFrontendManagementFeature
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        providers: [provideFeatureAddonRoutes([{
          useAddonSlot: 'management',
          path: 'password-link',
          data: {
            ...accessGuardData({
              allow: ["Feature.common-users-password-reset-qrcode.Manage", "Programmatic.common-users.IsCompanyManager"]
            })
          },
          canActivate: [AccessGuard],
          loadChildren: () => import('./password-link/password-link.module').then(m => m.ManagerPasswordLinkFrontendModule)
        }])]
      });
    }
  };
  UsersPasswordResetQrcodeFrontendManagementFeature = __decorate([ClassName("UsersPasswordResetQrcodeFrontendManagementFeature")], UsersPasswordResetQrcodeFrontendManagementFeature);
  return UsersPasswordResetQrcodeFrontendManagementFeature;
})();
export { UsersPasswordResetQrcodeFrontendManagementFeature };